import { render, staticRenderFns } from "./JobOrderShowDetail.vue?vue&type=template&id=6966d5f2&"
import script from "./JobOrderShowDetail.vue?vue&type=script&lang=js&"
export * from "./JobOrderShowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports